export default __webpack_public_path__ + "static/media/canvasAndFramedA3WoodSmall.7d8b35d6.jpg";